import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NomePaginaEnum } from '@core/models/nome-pagina.enum';
import { EntidadeSharedDataService } from '@modules/entidade/entidade-shared-data.service';
import { GrupoService } from '@services/grupo.service';
import { addFormControls } from '@shared/util/util';

@Component({
  selector: 'app-grupos',
  templateUrl: './grupos.component.html',
  styleUrls: ['./grupos.component.scss']
})
export class GruposComponent implements OnInit, OnChanges {

  @Input() entidadeForm!: FormGroup;
  @Input() data: any;
  @Input() nomePagina!: NomePaginaEnum;
  @Input() somenteVisualizar!: any;

  grupoForm!: FormGroup;
  opcoesGrupos: any;
  nzFilterOption = (): boolean => true;

  constructor(
    private fb: FormBuilder,
    private grupoService: GrupoService
  ) { }

  ngOnInit(): void {
    this.construirForm();
    this.fetchOptions();
  }

  construirForm() {
    const nomeObs = this.nomePagina + 'Grupos';
    addFormControls(this.entidadeForm, {
      [nomeObs]: [''],
    });

    this.grupoForm = this.fb.group({
      grupos: []
    });

    this.grupoForm.valueChanges.subscribe(() => {
      this.emitirAlteracaoFormulario();
    });
  }

  emitirAlteracaoFormulario() {
    if (this.grupoForm.dirty) {
      const objEnvio = { ...this.grupoForm.getRawValue() };

      objEnvio.grupos = objEnvio.grupos
        .filter((item: any) => {
          const idGrupo = typeof item === 'number' ? item : item.idGrupo || item.id;
          return typeof idGrupo === 'number' && idGrupo > 0;
        })
        .map((item: any) => {
          const idGrupo = typeof item === 'number' ? item : item.idGrupo || item.id;
          const idEntidade = this.data?.id;

          const obj: any = {
            idEntidade,
            idGrupo
          };
          if (item.id !== undefined && item.id !== idGrupo) {
            obj.id = item.id;
          }
          return obj;
        });

      const nomeObs = this.nomePagina + 'Grupos';
      this.entidadeForm.get(nomeObs)?.setValue(objEnvio.grupos);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(this.data && this.data.entidadeGrupos) {
      this.fetchOptions();
    }
  }

  fetchOptions(): void {
    const tipo = "Entidade";
    this.grupoService.combo(tipo).subscribe(options => {
      options.forEach((item: any) => {
        item.idGrupo ??= item.id;
      });
      this.opcoesGrupos = options;
      this.setSelectedOption();
    });
  }

  setSelectedOption(): void {
    const grupos = this.data?.entidadeGrupos;
    const modificarArray = grupos
      ?.filter((item: any) => typeof item.idGrupo === 'number' && item.idGrupo > 0)
      .map((item: any) => {
        return item
      });
    this.grupoForm.patchValue({ grupos: modificarArray });
  }

  compareFn(a: any, b: any): boolean {
    return a?.idGrupo === b?.idGrupo;
  }

}
